
import { useState } from "react";
import Input from '../../Input';
import { FiUser } from 'react-icons/fi';
import Button from '../../Button';
import { SearchUsers } from '../../../api/Repricing/repricing';

function CompetitionSearchUsers({getfoundUsers}){  
    const [search, setSearch] = useState("");
    const [foundUsers, setFoundUsers] = useState([]);
    const searchUsers = async () => {
          try {
            const  data  = await SearchUsers(search);
            setFoundUsers(data.data || []);
           // getfoundUsers(data,data || []);
          } catch (error) {
            console.error("Error fetching added users:", error);
          }
      }

      return (
        <div>
         <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end">
                <Input label="Szukaj użytkownika" value={search} onChange={e => setSearch(e.target.value)} size="small" className="w-full mb-2 text-xs" fullWidth placeholder="Wprowadź dane..." />
                <Button className="h-fit self-end sm:w-auto mb-3" variant="contained" size="small" onClick={()=>searchUsers()} >SZUKAJ</Button>
                </div>
                   <div className="max-h-[300px] overflow-y-auto">

 {foundUsers.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-10 text-center text-gray-500">

  <p className="text-sm font-semibold">Brak wyników</p>
  <p className="mt-1 text-xs text-gray-400">
    Nie znaleziono żadnych danych do wyświetlenia.
  </p>
</div>
          ):(
            <div>
              {foundUsers.map((foundUsers, index) => (
                <div
                key={index}
                onClick={()=>getfoundUsers(foundUsers)}
                className="
                    bg-white
                    border
                    border-gray-200
                    rounded
                    p-3
                    mb-1 hover:shadow-sm transition-shadow"
            >
    
                <div className="
                    flex
                    items-center
                    justify-between
                ">
    
                    <div className="flex flex-col min-w-0">
    
    <div className="grid gap-2">
        <div className="flex items-center gap-1">
             <span className="text-xs text-gray-300 truncate">
                {foundUsers.id}
            </span>
            <span className="text-xs font-semibold text-gray-900 truncate">
                {foundUsers.shop_name}
            </span>
             <span className="text-xs font-medium text-gray-500">-</span>
            <span className="text-xs text-gray-900 truncate">
                {foundUsers.client_email}
            </span>
        </div>
    
       
    </div>
                       
    
    
                     
    
                    </div>
    
    
    
                    <FiUser 
                        size={16}
                        className="text-gray-400"
                    />
    
                </div>
    
    
    
            </div>
              ))}
            </div>
          )}
          </div>
                </div>
                
      );
}
export default CompetitionSearchUsers;